import React, { useEffect, useRef, useState } from 'react'
import { FormSection, formValueSelector } from 'redux-form'
import { connect, useDispatch, useSelector } from 'react-redux'
import { specteraLensesConfigurationsLoad } from '../../../../../../../../../redux/actions/addOns/rpa/vision_insurance/spectera/specteraAction'
import SpecteraLabPrescriptionSection from './lensBenefit/SpecteraLabPrescriptionSection'
import SpecteraLensesSection from './lensBenefit/SpecteraLensesSection'
import SpecteraPatientFrameNotFoundSection from './lensBenefit/SpecteraPatientFrameNotFoundSection'
import { LAB_LENSES_FIELD_CONFIG, NONLAB_LENS_FIELD_CONFIG, SPECTERA_CLAIM_FORM } from './lensBenefit/constants'

function SpecteraLensBenefit(props) {
  const { portalType, visionInsuranceClaimForm, specteraAddOn, specteraVisionInsuranceOS } = props
  const dispatch = useDispatch()
  const selectedLocation = specteraAddOn?.config?.locations.find(loc => loc.name === specteraAddOn.config.creds.location) || {}
  const prescriptionLensType = useSelector((state) =>
    formValueSelector(SPECTERA_CLAIM_FORM)(state, 'lab_prescription.prescription_lens_type')
  )
  const lensConfigurations =
    specteraVisionInsuranceOS?.lenses_configurations ||
    props.specteraVisionInsurance?.lenses_configurations ||
    []

  const hasFrameBenefit = props.hasFrameBenefit ?? Boolean(
    visionInsuranceClaimForm?.eligibility?.data?.find(
      (item) => item.service_type === 'Frame Benefit'
    )?.active
  )
  const showPatientFrameNotFound = props.showPatientFrameNotFound ?? !hasFrameBenefit

  const effectivePortalType =
    (portalType || specteraAddOn?.config?.portal_type || 'lab').toString().toLowerCase()

  const [loading, setLoading] = useState(false)
  const lastLoadedFiltersRef = useRef('')
  const inFlightRef = useRef(false)

  const handleLoadLensConfigurations = (lensTypeId) => {
    const rawLensTypeId =
      typeof lensTypeId === 'object'
        ? lensTypeId?.lens_type_id || lensTypeId?.prescription_lens_type
        : lensTypeId

    // In lab mode, do not call without a selected lens type
    if (effectivePortalType === 'lab' && (rawLensTypeId === undefined || rawLensTypeId === null || rawLensTypeId === '')) {
      return Promise.resolve()
    }

    const filters = {
      lens_type: 'os',
      location_id: selectedLocation?.id || '',
    }

    if (rawLensTypeId !== undefined && rawLensTypeId !== null && rawLensTypeId !== '') {
      filters.lens_type_id = rawLensTypeId
    }

    const requestKey = `${visionInsuranceClaimForm?.id}_${JSON.stringify(filters)}`
    if (lastLoadedFiltersRef.current === requestKey || inFlightRef.current) {
      return Promise.resolve()
    }

    lastLoadedFiltersRef.current = requestKey
    inFlightRef.current = true
    setLoading(true)

    return dispatch(
      specteraLensesConfigurationsLoad(visionInsuranceClaimForm?.id, filters)
    ).finally(() => {
      inFlightRef.current = false
      setLoading(false)
    })
  }

  useEffect(() => {
    if (effectivePortalType === 'lab') {
      if (prescriptionLensType) {
        handleLoadLensConfigurations(prescriptionLensType)
      }
    } else {
      handleLoadLensConfigurations({ lens_type: 'os' })
    }
  }, [])

  const loader = loading && (
    <div className="row">
      <div className="form-group col-3 d-flex align-items-end pb-5">
        <div className="spinner-border spinner-border-sm text-primary" role="status" />
        <span className="ml-2 text-muted">Loading...</span>
      </div>
    </div>
  )

  return (
    <div>
      <h5 className='mb-5'>Lens Benefit</h5>

      {effectivePortalType === 'lab' && (
        <>
          {showPatientFrameNotFound && <SpecteraPatientFrameNotFoundSection isLenses={true} />}
          <SpecteraLabPrescriptionSection onLensTypeChange={handleLoadLensConfigurations}/>
          <h5 className='mb-5 mt-6'>Lenses</h5>
          <FormSection name="lab_lenses">
            <SpecteraLensesSection
              fieldConfig={LAB_LENSES_FIELD_CONFIG}
              formSection="lab_lenses"
              lensConfigurations={lensConfigurations}
              lensConfigurationsLoading={loading}
              claimId={visionInsuranceClaimForm?.id}
              locationId={selectedLocation?.id}
            />
            {loader}
          </FormSection>
        </>
      )}

      {effectivePortalType === 'nonlab' && (
        <FormSection name="lens">
          <SpecteraLensesSection
            fieldConfig={NONLAB_LENS_FIELD_CONFIG}
            formSection="lens"
            lensConfigurations={lensConfigurations}
            lensConfigurationsLoading={loading}
            claimId={visionInsuranceClaimForm?.id}
            locationId={selectedLocation?.id}
          />
          {loader}
        </FormSection>
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  const { visionInsurance, specteraVisionInsurance } = state
  return {
    specteraAddOn: visionInsurance?.services?.find(item => item.config.service === "spectera") || false,
    specteraVisionInsuranceOS: specteraVisionInsurance.os,
    specteraVisionInsurance,
  }
}

export default connect(mapStateToProps)(SpecteraLensBenefit)
